import React, { FC, PropsWithChildren, ReactElement, ReactNode } from 'react';

export const SENSITIVE_CLASS_NAME = '__sensitive';

export type SensitiveProps = PropsWithChildren<{}>;

/**
 * Marks the content as sensitive which can be used as a hint to omit it from showing up in Sentry's session
 * replay functionality.
 */
export const Sensitive: FC<SensitiveProps> = ({ children }) => {
  const addSentryIgnoreClass = (child: ReactNode) => {
    // A Fragment is a valid element but can't take a className, so cloning one
    // with a className triggers a React warning — wrap those (and non-elements)
    // in a marked <span> instead.
    if (React.isValidElement(child)) {
      const element = child as ReactElement<{ className?: string }>;

      return React.cloneElement(element, {
        className: [element.props.className, SENSITIVE_CLASS_NAME]
          .filter(Boolean)
          .join(' '),
      });
    }

    return <span className={SENSITIVE_CLASS_NAME}>{child}</span>;
  };

  return <>{React.Children.map(children, addSentryIgnoreClass)}</>;
};
